const googleSlidesFileURL = "https://docs.google.com/presentation/";

export const validateGoogleSlidesFileURL = (value: string) => {
  return value.toLowerCase().indexOf(googleSlidesFileURL) === 0;
};
